import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'app-selector-ubicacion',
  templateUrl: './selector-ubicacion.component.html',
  styleUrls: ['./selector-ubicacion.component.scss']
})
export class SelectorUbicacionComponent implements OnInit {
  @Input() options = null;
  @Input() mensajeSeleccion = '';
  @Input() selectedValue = null;
  @Output() selected: EventEmitter<any> = new EventEmitter();

  get hasValueSelected(){
    if(this.options!=null && this.options.length>0 && this.selectedValue!=null){
      var optionFound = this.options.find(opt => opt.value === this.selectedValue);
      if (optionFound) return true;
    }
    return  false;
  }

  constructor() {}

  ngOnInit(): void {}

  selectValue(event){ //Avisa al componente padre del value del select
    this.selected.emit(event.target.value);
    this.selectedValue = event.target.value;
  }
}
